import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const JobExecutionHistoryList = Loadable(
  lazy(() => import("features/notification/jobHistory/components/List"))
);

const routes = {
  path: "job-history",
  children: [{ path: "", element: <JobExecutionHistoryList /> }],
};

export default routes;
